export default __webpack_public_path__ + "static/media/bulb2.16e2193e.png";